import { apiService } from "../services/api";

export type PrintColumnReportMeta = { name: string; label: string };
export type PrintColumnMeta = {
  key: string;
  label: string;
  reports: PrintColumnReportMeta[];
};

export type PrintColumnSettingsPayload = {
  columns: Record<string, Record<string, boolean>>;
};

export type PrintColumnSettingsResponse = {
  success?: boolean;
  setting?: PrintColumnSettingsPayload;
  meta?: PrintColumnMeta[];
  message?: string;
};

export async function getPrintColumnSettings(): Promise<PrintColumnSettingsResponse> {
  return (await apiService.get(
    "/pabws/api/print_column_settings"
  )) as PrintColumnSettingsResponse;
}

export async function savePrintColumnSettings(
  payload: PrintColumnSettingsPayload
): Promise<PrintColumnSettingsResponse> {
  return (await apiService.post(
    "/pabws/api/print_column_settings",
    payload
  )) as PrintColumnSettingsResponse;
}
